// `errorValueType` is declared as `string[]` app-wide (a model's `errors` yields arrays)
// and `useForm` narrows the keys to the form's own fields, but these controllers ship one
// message per key — zod's, which is what the forms render — plus `base` for the refusals
// the Next actions reported as `serverState.globalError`.
export function errorMessages(errors: unknown) {
  return errors as Record<string, string | undefined>;
}
